import React from "react";
// import "../../Leads/leaddetails.scss";
import CaseMasterDetails from "./CaseMasterDetails";
import { catchError } from "../../../utils/Utils";
import "./caseDetails.scss";
import {
  CaseStatusEnum,
  CaseTaskEnum,
  ICaseDetailsModel,
  ICaseStatusModel,
  ICaseTaskModel,
} from "../../../models/Cases/CaseDetailsModel";
import { AxiosError, AxiosResponse } from "axios";
import CaseTasksContainer from "../CaseTasks/CaseTasksContainer";
import CaseTaskForm from "../CaseTasks/CaseTaskForm";
// import LeadDetailsDisplay from "../../Leads/LeadDetails/LeaddetailsFC/LeadDetailsDisplayFc";
import sideOutArrowIcon from "../../../images/side-out-arrow.svg";
import slideBackIcon from "../../../images/slide-back.svg";
import CreateCaseFrom from "../CreateCaseFrom";
import CaseCommentsRC from "../CaseComments/CaseCommentsRC";
import { SubmissionError } from "redux-form";
import { toast } from "react-toastify";
import { Modal as ModalPopup } from "react-bootstrap";
import { transformDateWithDash } from "../../../utils/dateUtil";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import Service from "../../../services";
import { BankUserContext } from "../../../bankUserContext";
import { Navigate } from "react-router-dom";
import LeadData from "../../procpectingDetailPge/LeadData";
import FinSpinner from "../../../commonfields/FinSpinner";
import { catchErrorGeneric } from "../../../utils/GeneralUtils";

interface CaseDetailsPageState {
  setRedirection: boolean;
  loader: boolean;
  leadId: string;
  leaddetails: any | null;
  caseDetails: ICaseDetailsModel | null;
  disableforsuperuser: boolean;
  expand: boolean;
  caseSatusDetails: ICaseStatusModel[] | [];
  caseTaskModal: boolean; // CaseTaskEnum | string;
  selectedTask: ICaseTaskModel | null;
  showCreateLeadModal: boolean;
  allLORClients: any;
  formChange: number;
  accordianOpen: string | null;
  deletedDocuments: any;
  suggestedUsersList: any;
  displayVerifySuccess: boolean;
  verifyErrors: any;
  orgId: string | null | undefined;
}

class CaseDetailsPage extends React.Component<
  WithRouterProps<unknown>,
  CaseDetailsPageState
> {
  service: Service;
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: WithRouterProps<unknown>) {
    super(props);
    this.state = {
      setRedirection: false,
      loader: false,
      leadId: "",
      leaddetails: null,
      caseDetails: null,
      disableforsuperuser: false,
      expand: false,
      caseSatusDetails: [],
      caseTaskModal: false,
      selectedTask: null,
      showCreateLeadModal: false,
      allLORClients: null,
      formChange: 0,
      accordianOpen: null,
      deletedDocuments: [],
      suggestedUsersList: [],
      displayVerifySuccess: false,
      verifyErrors: null,
      orgId: this.context?.bankuserDetails?.organization?.orgId,
    };
    this.service = new Service();
  }
  // componentDidUpdate(prevProps: WithRouterProps<unknown>, prevState: CaseDetailsPageState) {
  //   if (this.context?.bankuserDetails?.organization?.orgId !== prevState.orgId) {
  //     this.setState({ orgId: this.context?.bankuserDetails?.organization?.orgId })
  //
  //   }
  // }

  toggleCaseTaskModal = () => {
    this.setState({ caseTaskModal: !this.state.caseTaskModal });
    if (this.state.caseTaskModal) {
      this.setState({ verifyErrors: null });
    }
  };

  setSelectedTask = (value: ICaseTaskModel | null) =>
    this.setState({ selectedTask: value });

  setDisplayVerifySuccess = (value: boolean) =>
    this.setState({ displayVerifySuccess: value });

  setVerifyErrors = (value: any) => this.setState({ verifyErrors: value });

  setExpand = (value: boolean) => {
    if (value) {
      this.getClienLeadDetails();
    }
    this.setState({ expand: value });
  };

  setAccordianOpen = (value: string | null) =>
    this.setState({ accordianOpen: value });

  setDeletedDocuments = (value: any) =>
    this.setState({ deletedDocuments: value });

  createLeadModal = () => {
    if (this.state.showCreateLeadModal) {
      if (this.props.params.id) {
        this.getFinCaseByCaseId(this.props.params.id);
        this.setDeletedDocuments([]);
      }
    }
    this.setState({
      showCreateLeadModal: !this.state.showCreateLeadModal,
    });
  };

  handleFormChange = (changedValue: number) => {
    this.setState({ formChange: changedValue });
  };

  getValue = (element: any) => {
    if (element) {
      const company = element.company ? (element.company.length > 15 ? `${(element?.company).slice(0, 15)}...` : element?.company) : "--"
      const productName = element.productName ? (element.productName.length > 15 ? `${(element?.productName).slice(0, 15)}...` : element?.productName) : "--"
      const account = element.account ? (element?.account.length > 10 ? `${(element?.account).slice(0, 10)}...` : element?.account) : "--"
      return `${company} (${productName} - ${account})`
    }
  }

  getAllLORClients = () => {
    this.service
      .getAllLORClients(this.context?.bankuserDetails?.organization?.orgId)
      .then((response: any) => {
        const data = response.data.map((element: any) => {
          return { text: this.getValue(element), value: element.clientId };
        });
        this.setState({ allLORClients: data });
      });
  };

  getAllManualTodoUsers = () => {
    this.service
      .getAllManualTodoUsers(this.context?.bankuserDetails?.organization?.orgId, 4)
      .then((response: any) => {
        const data = response?.data
          ?.filter((value: any) => value?.firstName || value?.lastName)
          ?.map((each: any) => ({
            id: each?.userId,
            display: `${each?.firstName ?? ""} ${each?.lastName ?? ""}`,
          }));
        this.setState({ suggestedUsersList: data });
      });
  };

  setCaseStatus = (caseData: ICaseDetailsModel | null) => {
    let caseStatus: ICaseStatusModel[] = [];
    if (caseData?.caseCode) {
      caseStatus = [
        ...caseStatus,
        {
          heading: "Case ID",
          value: [caseData?.caseCode],
        },
      ];
    }
    if (caseData?.caseManager) {
      caseStatus = [
        ...caseStatus,
        {
          heading: "Case Manager",
          value: [caseData?.caseManager],
        },
      ];
    }
    if (caseData?.caseCreator) {
      caseStatus = [
        ...caseStatus,
        {
          heading: "Creator",
          value: [caseData?.caseCreator],
        },
      ];
    }
    this.setState({ caseSatusDetails: caseStatus });
  };

  getFinCaseByCaseId = (id: string) => {
    this.setState({ loader: true });
    this.service
      .getFinCaseByCaseId(id)
      .then((res: any) => {
        this.setState({ caseDetails: res?.data });
        this.setCaseStatus(res?.data);
        this.setState({ loader: false });
      })
      .catch((err: AxiosError) => {
        catchError(err, true);
        this.setState({ loader: false });
      });
  };

  getClienLeadDetails = () => {
    const clientId = this.state.caseDetails?.lor;
    if (clientId) {
      let payload = {
        screen: "ProspectDetails",
        sections: "ProspectInfo",
        clientId: clientId,
        isJsonReturnObject: true,
      };
      this.service
        .getLeadsData(payload)
        .then((res: any) => {

          const temp = res?.data?.map((r: any) => {
            const temp = r.contactInfo && r?.contactInfo?.[0] || [];
            const temp2 = r.businessInfo && r?.businessInfo?.[0] || [];

            r.clientLabels = r?.clientLabels || [];
            r.clientLabels = r?.clientLabels.map((l: any) => {
              l.value = l?.labelMasterId;
              return l;
            });
            if (r.contactInfo && r?.contactInfo[0]) {
              r.contactInfo[0].address = [
                temp?.streetAddress || "",
                temp?.unitSuite || "",
                [
                  temp?.city || " ",
                  temp?.state || " ",
                  temp?.zipCode || " ",
                ].join(" "),
              ].filter((d: any) => d);
            }
            if (r.businessInfo && r?.businessInfo[0]) {
              r.businessInfo[0].address = [
                temp2?.businessStreetAddress || "",
                temp2?.businessUnitSuite || "",
                [
                  temp2?.businessCity || "",
                  temp2?.businessState || "",
                  temp2?.businessZipCode || "",
                ].join(" "),
              ].filter((d: any) => d);
            }
            return r;
          });
          this.setState({ leaddetails: temp });
        })
        .catch((err: any) => { });
    }
  };

  componentDidMount() {
    if (this.props.params.id) {
      this.getFinCaseByCaseId(this.props.params.id);
    }
    this.getAllLORClients();
    this.getAllManualTodoUsers();
  }

  getTaskModalHeader = () => {
    const value = this.state.selectedTask?.type;
    if (value === CaseTaskEnum.KICK_OFF_TASK) return "Edit Kick-Off Task";
    else if (value === CaseTaskEnum.CLOSING_TASK) return "Edit Closing Task";
    else if (value === CaseTaskEnum.TASK) return "Edit Task";
    else return "Create New Task";
  };

  getCaseStatusChangeHandler = (caseId: string) => {
    this.service
      .changeCaseStatus(caseId)
      .then((res: any) => {
        if (res.status === 200) {
          toast.success("Case Status Changed Successfully");
          this.getFinCaseByCaseId(caseId);
        }
      })
      .catch((err: AxiosError) => {
        catchError(err, true);
      });
  };

  getTaskPayload = (values: any) => {
    return {
      ...values,
      ...(!this.state.selectedTask ||
        this.state.selectedTask?.type === CaseTaskEnum.TASK
        ? {
          predecessorTo:
            values?.predecessorTo?.map(
              (each: any) => each?.value?.value ?? each?.value
            ) || [],
          successorTo:
            values?.successorTo?.map(
              (each: any) => each?.value?.value ?? each?.value
            ) || [],
          ...(this.state.selectedTask
            ? { taskId: this.state.selectedTask?.taskId }
            : {}),
        }
        : {
          taskId: this.state.selectedTask?.taskId,
        }),
      dueDate: transformDateWithDash(values?.dueDate) || "",
      type: this.state.selectedTask?.type || CaseTaskEnum.TASK,
      completionNotificationId:
        values?.completionNotificationId?.map(
          (each: any) => each?.value?.value ?? each?.value
        ) || [],
      reachingDueDateNotificatonId:
        values?.reachingDueDateNotificatonId?.map(
          (each: any) => each?.value?.value ?? each?.value
        ) || [],
    };
  };

  editTask = (payload: any) => {
    this.service
      .editCaseTask(payload)
      .then(async () => {
        this.state.caseDetails &&
          this.getFinCaseByCaseId(this.state.caseDetails?.caseId);
        if (this.state.selectedTask?.taskId) {
          try {
            const taskResult = await this.getCaseTaskByTaskId(
              this.state.selectedTask.taskId
            );
            this.setState({ selectedTask: taskResult?.data });
          } catch (e) {
            catchError(e, true);
          }
        }
        this.setState({
          loader: false,
          caseTaskModal: false,
        });
      })
      .catch((err: any) => {
        if (err?.response?.data?.errorMessage) {
          toast.error(err?.response?.data?.errorMessage);
        } else catchError(err, true);
        this.setState({ loader: false });
      });
  };

  createTaskHandler = async (values: any) => {
    this.setState({ loader: true });
    const payload = this.getTaskPayload(values);
    if (this.state.selectedTask?.taskId) {
      if (this.state.caseDetails?.status === "IN_PROCESS") {
        const checkResults = await this.checkTask(values);
        if (checkResults?.data && checkResults?.status === 200) {
          const errorList = {};
          Object.entries(checkResults.data).forEach(([key, value]) => {
            if (value && key !== "isValidTask")
              Object.assign(errorList, { [key]: value });
          });
          if (Object.keys(errorList)?.length > 0) {
            this.setState({ loader: false });
            throw new SubmissionError({ ...checkResults?.data });
          } else this.editTask(payload);
        } else {
          this.setState({ loader: false });
          // toast.error('Something went wrong')
          catchErrorGeneric("Something went wrong");
        }
      } else {
        this.editTask(payload);
      }
    } else {
      this.service
        .createCaseTask(payload)
        .then(() => {
          this.state.caseDetails &&
            this.getFinCaseByCaseId(this.state.caseDetails?.caseId);
          this.toggleCaseTaskModal();
          this.setState({ loader: false });
        })
        .catch((err: any) => {
          if (err?.response?.data?.errorMessage) {
            toast.error(err?.response?.data?.errorMessage);
          } else catchError(err, true);
          this.setState({ loader: false });
        });
    }
  };

  checkTask = async (values: any) => {
    const payload = this.getTaskPayload(values);
    return await this.service.verifyTask(payload);
  };

  verifyTask = async (values: any, init = false) => {
    this.setState({ loader: true });
    const checkResults = await this.checkTask(values);
    if (checkResults?.data && checkResults?.status === 200) {
      const errorList = {};
      Object.entries(checkResults.data).forEach(([key, value]) => {
        if (value && key !== "isValidTask")
          Object.assign(errorList, { [key]: value });
      });
      if (Object.keys(errorList)?.length > 0) {
        this.setState({ loader: false });
        if (typeof init === "boolean" && init) {
          this.setState({ verifyErrors: errorList });
        } else {
          throw new SubmissionError({ ...errorList });
        }
      } else {
        this.setState({ loader: false });
        this.setDisplayVerifySuccess(true);
      }
    } else {
      this.setState({ loader: false });
      // toast.error('Something went wrong')
      catchErrorGeneric("Something went wrong");
    }
  };

  getCaseTaskByTaskId = async (id: string) => {
    if (this.state.caseDetails?.caseId) {
      return await this.service.getCaseTaskByTaskId(
        this.state.caseDetails?.caseId,
        id
      );
    } else return;
  };

  render() {
    const { expand } = this.state;

    return (
      <>
        {this.state.setRedirection && <Navigate to={`/caseTracker`} />}

        {this.state.loader ? <FinSpinner /> : <></>}

        <div
          className={`container-fluid w-100 caseMainWrap ${expand ? "expand" : ""
            }`}
        >
          <div className="caseTaskMainContainer ">
            <div className="leadDetailsTopSection">
              <div className="leadDetailsmaincardcontainer">
                {this.state.caseDetails != null ? (
                  <CaseMasterDetails
                    caseDetails={this.state.caseDetails}
                    disableforsuperuser={this.state.disableforsuperuser}
                    expand={this.state.expand}
                    setExpand={this.setExpand}
                    caseSatusDetails={this.state.caseSatusDetails}
                    createLeadModal={this.createLeadModal}
                    getCaseStatusChangeHandler={this.getCaseStatusChangeHandler}
                  />
                ) : (
                  <></>
                )}
              </div>

              {/* Show Lead details only if details are expanded */}
              {expand ? (
                <div className="leadDetailsonCard">
                  {this.state.leaddetails != null && (
                    <>
                      <LeadData
                        leadData={this.state.leaddetails}
                        getLeadData={this.getClienLeadDetails}
                        trackerName={"caseTracker"}
                      />
                      <div
                        className={`lead expand-btn ${expand ? "expand" : ""}`}
                        onClick={() =>
                          this.state.caseDetails?.lor && this.setExpand(!expand)
                        }
                      >
                        <img
                          src={expand ? slideBackIcon : sideOutArrowIcon}
                          alt="sideOutArrowIcon"
                        />
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
            {/* Case Tasks container */}
            <CaseTasksContainer
              caseDetails={this.state.caseDetails}
              toggleCaseTaskModal={this.toggleCaseTaskModal}
              setSelectedTask={this.setSelectedTask}
              selectedTask={this.state.selectedTask}
              getCaseTaskByTaskId={this.getCaseTaskByTaskId}
              accordianOpen={this.state.accordianOpen}
              setAccordianOpen={this.setAccordianOpen}
              verifyTask={this.verifyTask}
            />

            {/* Case comments and documents container */}
            <div className="caseCommentsContainer">
              <CaseCommentsRC
                disableforsuperuser={this.state.disableforsuperuser}
                caseDetails={this.state.caseDetails}
                suggestedUsersList={this.state.suggestedUsersList}
                getAllManualTodoUsers={this.getAllManualTodoUsers}
              />
            </div>
          </div>
        </div>

        <ModalPopup
          className="caseTaskModal"
          size="lg"
          show={this.state.caseTaskModal}
          onHide={this.toggleCaseTaskModal}
        >
          <ModalPopup.Header closeButton>
            <div className="caseTaskModal-header">
              {this.getTaskModalHeader()}
            </div>
          </ModalPopup.Header>
          <ModalPopup.Body>
            <CaseTaskForm
              caseDetails={this.state.caseDetails}
              selectedTask={this.state.selectedTask}
              setSelectedTask={this.setSelectedTask}
              createTaskHandler={this.createTaskHandler}
              verifyTask={this.verifyTask}
              loader={this.state.loader}
              displayVerifySuccess={this.state.displayVerifySuccess}
              setDisplayVerifySuccess={this.setDisplayVerifySuccess}
              verifyErrors={this.state.verifyErrors}
            />
          </ModalPopup.Body>
        </ModalPopup>

        <ModalPopup
          className="createCaseModal"
          size="xl"
          show={this.state.showCreateLeadModal}
          onHide={this.createLeadModal}
        >
          <ModalPopup.Header closeButton>
            <div className="caseTaskModal-header">Edit Case</div>
          </ModalPopup.Header>
          <ModalPopup.Body>
            <CreateCaseFrom
              toogleHandle={this.createLeadModal}
              title={"Edit Case"}
              handleFormChange={this.handleFormChange}
              allLORClients={this.state.allLORClients}
              caseDetails={this.state.caseDetails}
              edit={true}
              deletedDocuments={this.state.deletedDocuments}
              setDeletedDocuments={this.setDeletedDocuments}
            />
          </ModalPopup.Body>
        </ModalPopup>
      </>
    );
  }
}

export default withRouter<WithRouterProps<unknown>>(CaseDetailsPage);
